// extracted by mini-css-extract-plugin
module.exports = {"app":"app__4yCxR"};